<template>
  <div>
  </div>
</template>

<script>
export default {
  name: "QRScanConfigComponent",
}
</script>
